import React from "react";
import { ViewMorePayout } from "../../pages";

const ViewMorePayoutContainer = ({ payout, closeModal }) => {
  return <ViewMorePayout closeModal={closeModal} payout={payout} />;
};
export default ViewMorePayoutContainer;
